<payee-popup [onCancel]="cancel">
  <ng-template #payeePopupTitleTemplate>
    <h1>Ügyfélszolgálati kérés</h1>
  </ng-template>
  <ng-template #payeePopupDescriptionTemplate>
    <p>Küldjön e-mail értesítést a kiválasztott címzetteknek a megadott üzenettel.</p>
  </ng-template>

  <form
    class="send-custom-message-form"
    [formGroup]="form"
  >
    <payee-form-field width="max">
      <span payee-label>Címzett</span>
      <payee-dropdown
        width="max"
        formControlName="recipient"
        [options]="recipientOptions"
        [displayWith]="recipientDisplayWith"
      ></payee-dropdown>
    </payee-form-field>

    <payee-form-field width="max">
      <span payee-label>Üzenet</span>
      <textarea
        payee-input
        formControlName="message"
        rows="6"
        placeholder="Írja be az üzenetet..."
      ></textarea>
      @if (form.get("message")?.invalid && form.get("message")?.dirty) {
        <span payee-error>
          {{ "ERROR_MESSAGES.FIELD_REQUIRED" | translate }}
        </span>
      }
    </payee-form-field>
  </form>

  <ng-template #payeePopupSubmitTemplate>
    <button
      payee-button
      width="max"
      [disabled]="loading"
      (click)="submit()"
    >
      Küldés
    </button>
  </ng-template>
</payee-popup>
